module.exports = __webpack_public_path__ + "h5/img/index-opt2.d5f3d297.png";